import React from 'react';
import Auxiliary from '../../util/Auxiliary';
import Create from './Create';

const Index = (props) => {
  return (
    <Auxiliary>
      <h1 className="gx-mb-4">Registrasi HSE Passport</h1>
      <Create />
    </Auxiliary>
  );
}

export default Index;